import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("path", {
              fill: "#FF5537",
              d: "M11.95 2.7c1.525 0 2.988.606 4.066 1.684C17.094 5.462 17.7 6.925 17.7 8.45c0 1.924-.945 3.627-2.395 4.67 3.712.966 6.395 3.494 6.395 6.552 0 .47-.25.89-.653 1.167-.342.236-.777.361-1.222.361H4.075c-.99 0-1.875-.612-1.875-1.528 0-3.058 2.683-5.586 6.395-6.552C7.145 12.077 6.2 10.374 6.2 8.45c0-3.176 2.574-5.75 5.75-5.75zm0 11.5c-4.603 0-8.25 2.522-8.25 5.471l.007-.015c.03-.018.15.044.368.044h15.75c.152 0 .289-.04.373-.097l-.003-.115c-.144-2.81-3.587-5.185-7.959-5.285zm0-10C9.603 4.2 7.7 6.103 7.7 8.45s1.903 4.25 4.25 4.25 4.25-1.903 4.25-4.25c0-1.127-.448-2.208-1.245-3.005-.797-.797-1.878-1.245-3.005-1.245z",
              transform: "translate(-170 -272) translate(154 264) translate(16 8)"
            })
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }